// extracted by mini-css-extract-plugin
export default {"mapComponent":"map-component_mapComponent__PN8mY"};